export default function getCommonTrackingData({ isLoggedIn, userId, cityInfo }) {
    const pageURL = typeof window !== "undefined" ? window.location.href : "";
    const cityId = cityInfo?.city_id;
    const cityName = cityInfo?.city_name;

    return {
        dimension112: isLoggedIn ? "yes" : "no",
        dimension16: pageURL,
        dimension140: cityId || "N/A",
        dimension144: cityName || "N/A",
        dimension148: userId || "N/A"
    };
}
